import React from 'react';

const maritalStatusOptions = [
  { value: 'Single', label: 'Single' },
  { value: 'Married/Civil Partner', label: 'Married/Civil Partner' },
  {
    value: 'Divorced/Person whose Civil Partnership has been dissolved',
    label: 'Divorced/Person whose Civil Partnership has been dissolved',
  },
  {
    value: 'Widowed/Surviving Civil Partner',
    label: 'Widowed/Surviving Civil Partner',
  },
  { value: 'Separated', label: 'Separated' },
  { value: 'Not disclosed', label: 'Not disclosed' },
];

interface OtherDetailsType {
  details: string;
  maritalStatus: string;
}

interface OtherContactDetailsProps {
  otherDetails: OtherDetailsType;
  setOtherDetails: (value: OtherDetailsType) => void;
}

const OtherContactDetails: React.FC<OtherContactDetailsProps> = ({
  otherDetails,
  setOtherDetails,
}) => {
  return (
    <div className="govuk-body">
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <h1 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--l"
            htmlFor="other-contact-details-input"
          >
            Other contact details information
          </label>
        </h1>

        <textarea
          className="govuk-textarea"
          id="other-contact-details-input"
          name="otherDetails"
          rows={5}
          autoComplete="otherDetails"
          placeholder="Enter any other details"
          value={otherDetails.details ?? ''}
          onChange={e =>
            setOtherDetails({ ...otherDetails, details: e.target.value })
          }
        />
      </div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <h1 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--l"
            htmlFor="marital-status"
          >
            Current marital status
          </label>
        </h1>
        <select
          className="govuk-select"
          id="marital-status"
          name="marital-status"
          value={otherDetails.maritalStatus ?? ''}
          onChange={e => {
            setOtherDetails({ ...otherDetails, maritalStatus: e.target.value });
          }}
        >
          <option value="" disabled>
            Marital status
          </option>
          {maritalStatusOptions?.map(option => {
            return (
              <option
                value={option.value}
                className="govuk-header__link"
                key={option.value}
              >
                {option.label}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default OtherContactDetails;
